export default __webpack_public_path__ + "static/media/USDT.f0aa6eb2.svg";